import React from 'react';

type KPISectionProps = {
  title: string;
  showKpi: number;
  clickKpi: number;
  showLabel: string;
  clickLabel: string;
};

export const KPISection: React.FC<KPISectionProps> = ({ title, showKpi, clickKpi, showLabel, clickLabel }) => (
  <div className="flex gap-2 flex-col mt-2 bg-shades-primary-active rounded-xl p-4">
    <p className="text-white font-bold text-md text-center">{title}</p>
    <div className="flex w-full justify-around">
      <span className="flex flex-col items-center">
        <dd className="text-4xl font-semibold tracking-tight text-white">{showKpi}</dd>
        <dd className="mt-1 text-md font-semibold tracking-tight text-white text-center">{showLabel}</dd>
      </span>
      <span className="flex flex-col items-center">
        <dd className="text-4xl font-semibold tracking-tight text-white">{clickKpi}</dd>
        <dd className="mt-1 text-md font-semibold tracking-tight text-white text-center">{clickLabel}</dd>
      </span>
    </div>
  </div>
);
